<template>
  <div class="flex flex-col">
    <rm-checkbox-square-filter
      v-for="checkbox in slicedCheckboxes"
      :id="checkbox.id"
      :key="`${checkbox.id}-square`"
      :meta="checkbox.meta"
      :checked="computedState(checkbox.id)"
      :label="checkbox.name"
      :slug="checkbox.slug"
      :count="checkbox.count"
      :has-selected-in-group="hasSelectedInGroup"
      class="my-2"
      @click-checkbox="value => clickCheckbox(value, checkbox)"
    />
    <button
      v-if="checkboxes.length > maxCount"
      class="text-blue-500 text-sm"
      @click="isOpened = !isOpened"
    >
      {{ isOpened ? 'Свернуть' : 'Показать ещё' }}
    </button>
  </div>
</template>

<script setup>
import RmCheckboxSquareFilter from '~/components/shared/rm_checkbox_square_filter.vue'

const props = defineProps({
  checkboxes: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'square',
  },
  checked: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['change', 'changeItem'])

const isOpened = ref(false)

const countChecked = computed(() => {
  return props.checkboxes.filter(checkbox => {
    return computedState(checkbox.id)
  }).length
})

const maxCount = computed(() => {
  return countChecked.value > 5 ? countChecked.value : 5
})

const hasSelectedInGroup = computed(() => {
  return props.checkboxes.some(checkbox => {
    return computedState(checkbox.id)
  })
})

const slicedCheckboxes = computed(() => {
  if (isOpened.value) {
    return props.checkboxes
  }
  return props.checkboxes.slice(0, maxCount.value)
})

const clickCheckbox = (value, fullValue) => {
  emit('changeItem', value, fullValue)
}

const computedState = (id) => {
  return !!props.checked.find(item => {
    return Number(item) === Number(id)
  })
}

watch(() => props.checked, () => {
  emit(
    'change',
    props.checked.map(item => {
      delete item.checked
      return item
    }),
  )
})
</script>
